/**
 * NASCAR Countdown
 *
 * Reads `data-target` (YYYY-MM-DD HH:MM:SS, local time) from each
 * `.ncd-timer` element and counts down to that date, updating the
 * [data-unit] value spans every second.
 */

function updateTimer(timer) {
    const target = new Date(timer.dataset.target.replace(' ', 'T'));
    const now    = new Date();
    const diff   = Math.max(0, target - now);

    const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const values = { days, hours, minutes, seconds };

    timer.querySelectorAll('.ncd-value[data-unit]').forEach(function(el) {
        el.textContent = values[el.dataset.unit] !== undefined
            ? String(values[el.dataset.unit]).padStart(2, '0')
            : '00';
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const timers = document.querySelectorAll('.ncd-timer[data-target]');
    if (!timers.length) return;

    timers.forEach(function(timer) {
        if (!timer.dataset.target) return;
        updateTimer(timer);
        setInterval(function() { updateTimer(timer); }, 1000);
    });
});
